// Vendors
import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
// Types
import { FeatureFlagsContextType } from './types/feature-flags.context.type';
import { FeatureFlagType } from 'types/feature-flag.type';

const FeatureFlagsContext = createContext<FeatureFlagsContextType>({} as FeatureFlagsContextType);

const FeatureFlagsContextProvider = ({ children }: PropsWithChildren): React.ReactElement => {
  const [featureFlags, setFeatureFlags] = useState<FeatureFlagType[]>([]);

  return (
    <FeatureFlagsContext.Provider value={{ featureFlags, setFeatureFlags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

const useFeatureFlagsContextHook = (): FeatureFlagsContextType => useContext(FeatureFlagsContext);

export { useFeatureFlagsContextHook, FeatureFlagsContextProvider };
